import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment'; // 巡检分析
//import inspection from '@views/bi/report/inspection'

import dateSelect from '@/components/date/dateSelect';
import weekSelect from '@/components/date/weekSelect';
import monthSelect from '@/components/date/monthSelect';
import quarterSelect from '@/components/date/quarterSelect';
import yearSelect from '@/components/date/yearSelect';
import yearRange from '@/components/date/yearRange';
var options = [{
  label: '出水口',
  value: '1'
}, {
  label: '进水口',
  value: '2'
}];
var parentWidth = '160px';
var childWidth = '80px';
export default {
  name: 'WaterReport',
  mixins: [GetSiteIdMixin, JeecgListMixin],
  components: {
    dateSelect: dateSelect,
    weekSelect: weekSelect,
    monthSelect: monthSelect,
    quarterSelect: quarterSelect,
    yearSelect: yearSelect,
    yearRange: yearRange
    /*, inspection*/

  },
  data: function data() {
    var _this = this;

    return {
      showChart: true,
      inspectionType: 2,
      minList: {},
      maxList: {},
      avgList: {},
      columns: [],
      autoLoadInit: false,
      scroll: {
        y: 500
      },
      // 出水口
      columns1: [{
        title: '巡检时间',
        align: 'center',
        width: '150px',
        dataIndex: 'dateStr',
        colName: 'date_Str',
        customRender: function customRender(text, record, index) {
          return record.children ? text : index + 1;
        }
      },
      /*{
        title: '巡检人员',
        align: 'center',
        width: '150px',
        children: [
          {
            title: '员',
            align: 'center',
            width: '150px',
            dataIndex: 'realName',
            customRender: (text, record, index) => {
              return this.renderCol1('realName', text, record)
            }
          }
        ]
      },
      {
        title: '实际时间始',
        align: 'center',
        width: '150px',
        dataIndex: 'stime',
        customRender: (text, record, index) => {
          return this.renderCol1('stime', text, record)
        }
      },
      {
        title: '实际时间末',
        align: 'center',
        width: '150px',
        dataIndex: 'etime',
        customRender: (text, record, index) => {
          return this.renderCol1('etime', text, record)
        }
      },
      {
        title: '天气',
        align: 'center',
        width: '150px',
        dataIndex: 'weather',
        customRender: (text, record, index) => {
          return this.renderCol1('weather', text, record)
        }
      },
      {
        title: '温度',
        align: 'center',
        width: '150px',
        dataIndex: 'temperature',
        children: [
          {
            title: '°C',
            align: 'center',
            width: '150px',
            dataIndex: 'temperature',
            customRender: (text, record, index) => {
              return this.renderCol1('temperature', text, record)
            }
          }
        ]
      }, {
        title: '湿度',
        align: 'center',
        width: '150px',
        dataIndex: 'humidity',
        children: [
          {
            title: 'RH',
            align: 'center',
            width: '150px',
            dataIndex: 'humidity',
            customRender: (text, record, index) => {
              return this.renderCol1('humidity', text, record)
            }
          }
        ]
      },
      {
        title: '条数/状态',
        align: 'center',
        width: '150px',
        children: [
          {
            title: '是否',
            align: 'center',
            width: '150px',
            dataIndex: 'frequency',
            customRender: (text, record, index) => {
              return this.renderCol('frequency', text, record)
            }
          }
        ]
      }*/
      {
        title: '日常巡检',
        align: 'center',
        width: '150px',
        children: [{
          title: '总数/异常',
          align: 'center',
          width: '150px',
          dataIndex: 'frequency',
          customRender: function customRender(text, record, index) {
            return _this.renderCol('frequency', text, record);
          }
        }]
      }, {
        title: '周巡检',
        align: 'center',
        width: '150px',
        children: [{
          title: '总数/异常',
          align: 'center',
          width: '150px',
          dataIndex: 'frequency',
          customRender: function customRender(text, record, index) {
            return _this.renderColWeek('weekFrequency', text, record);
          }
        }]
      }],
      currentKey: '1',
      url: {
        list: '/inspection/find/report',
        exportXlsUrl: '/inspection/find/exportXlsForInspection',
        importExcelUrl: '/inspection/find/importExcel'
      },
      options: options,
      value: ['1'],
      reportType: '2',
      limitSelectDate: {},
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },

      /* 图表相关*/

      /* 柱状图*/
      legendData: [],
      seriesData: [],
      xAxisData: [],
      yAxisSolidWasteNumData: [],
      colorData: '',

      /* 柱状图*/
      callbackKey2: {}
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.queryParam.sdateBack = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.queryParam.edateBack = this.limitSelectDate.max.format('YYYY-MM-DD');
    this.queryParam.flag = '2';
    this.columns = this.columns1;
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.siteId = ids[1];
      this.queryParam.scope = ids[0];
      this.dataSource = [];
      this.loadData(this.reportType);
      /*this.loadData(3)*/
    }
  },
  methods: {
    /* 动态获取颜色*/
    getColor: function getColor(param) {
      //首先定义一个数组
      var colorList = ['#C33531', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3', '#B74AE5', '#0AAF9F', '#E89589', '#f7acbc', '#deab8a', '#817936', '#444693', '#ef5b9c', '#fedcbd', '#494e8f', '#b7ba6b', '#b2d235', '#905d1d', '#d71345', '#ca8687', '#007d65', '#d5c59f', '#00ae9d', '#78331e', '#74787c', '#008792', '#ad8b3d', '#6f599c', '#ef4136', '#543044'];
      return colorList[param];
    },
    //巡检分析单选

    /*图表分析 inspectionChangeRadio(e) {
      this.inspectionType = e.target.value
    },*/

    /* 图表相关*/
    drawChart1: function drawChart1() {
      var myEchart = this.$echarts.init(document.getElementById('histogramMain'));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: this.legendData
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        title: {
          text: 'Histogram',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#ccc'
          }
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData
        },
        yAxis: {
          type: 'value'
        },
        color: this.colorData,
        series: this.seriesData
      };
      myEchart.setOption(option);
    },

    /*图表分析*/
    callback: function callback(key) {
      if (key === '2') {
        this.currentKey = key; // this.drawChart1()

        this.loadData(this.reportType, this.currentKey);
        this.$msgbox;
      } else if (key === '1') {
        this.currentKey = '1';
        this.visible = true;
      }
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon: function expandIcon(props) {
      var h = this.$createElement;

      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return h("a", {
              "style": "color: 'black',margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "attrs": {
                "type": "caret-down"
              }
            })]);
          } else {
            return h("a", {
              "style": "color: 'black' ,margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "style": "color:red",
              "attrs": {
                "type": "caret-right"
              }
            })]);
          }
        } else {
          return h("span", {
            "style": "margin-right:0px"
          });
        }
      }
    },
    searchQuery: function searchQuery() {
      this.dataSource = [];
      this.loadData(this.reportType);
      /*if (this.reportType == 1){
        this.dataSource = []
        this.loadData(3)
      }else {
        this.loadData(this.reportType)
      }*/
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;

      /* 外层*/
      if (record.frequency) {
        if (0 == record.warnFrequency) {
          return h("span", [record.frequency, "\u6761"]);
        } else {
          return h("span", [record.frequency, "\u6761 /", h("span", {
            "style": "color:red"
          }, [record.warnFrequency]), "\u6761"]);
        }
      } else if (!record.frequency && record.abnormalStr) {
        // 内层
        if (record.status == '1' && record.stime && record.etime) {
          //  有对象 有正常数据
          return record.abnormalStr;
        } else if (record.status == '1' && (!record.stime || !record.etime)) {
          // 有对象 没数据
          return h("span", [h("a-icon", {
            "style": "color:red",
            "attrs": {
              "type": "question-circle",
              "theme": "filled"
            }
          }), " \u5DE1\u68C0\u672A\u5B8C\u6210 \u6570\u636E\u5F85\u5F55\u5165"]);
        } else {
          //  有对象 有异常数据
          return h("span", {
            "class": "redText"
          }, [h("a-icon", {
            "attrs": {
              "type": "warning",
              "theme": "filled"
            }
          }), record.abnormalStr]);
        }
      } else {
        return '-';
      }
    },
    renderColWeek: function renderColWeek(code, text, record) {
      var h = this.$createElement;

      /* 外层*/
      if (record.weekFrequency) {
        if (0 == record.warnFrequency) {
          return h("span", [record.weekFrequency, "\u6761"]);
        } else {
          return h("span", [record.weekWarnFrequency, "\u6761 /", h("span", {
            "style": "color:red"
          }, [record.weekWarnFrequency]), "\u6761"]);
        }
      } else if (!record.weekWarnFrequency && record.abnormalStr) {
        // 内层
        if (record.status == '1' && record.stime && record.etime) {
          //  有对象 有正常数据
          return record.abnormalStr;
        } else if (record.status == '1' && (!record.stime || !record.etime)) {
          // 有对象 没数据
          return h("span", [h("a-icon", {
            "style": "color:red",
            "attrs": {
              "type": "question-circle",
              "theme": "filled"
            }
          }), " \u5DE1\u68C0\u672A\u5B8C\u6210 \u6570\u636E\u5F85\u5F55\u5165"]);
        } else {
          //  有对象 有异常数据
          return h("span", {
            "class": "redText"
          }, [h("a-icon", {
            "attrs": {
              "type": "warning",
              "theme": "filled"
            }
          }), record.abnormalStr]);
        }
      } else {
        return '-';
      }
    },
    renderCol1: function renderCol1(code, text, record) {
      if (record.frequency) {
        return '-';
      } else {
        return text;
      }
    },
    loadData: function loadData(type) {
      var _this2 = this;

      if (!this.queryParam.sdateBack || !this.queryParam.edateBack) {
        this.$message_custom('请选择时间', 'error');
        return;
      }

      if (this.reportType == 8 && this.queryParam.sdateBack.length == 7 && this.queryParam.sdateBack.substring(this.queryParam.sdateBack.length - 2)) {
        this.queryParam.sdateBack = moment().format('YYYY-MM-DD');
        this.queryParam.quantum = moment().format('YYYY-MM-DD');
      }

      this.queryParam.type = type;
      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          /* 图表相关*/
          _this2.seriesData = [];
          _this2.xAxisData = [];
          _this2.yAxisSolidWasteNumData = [];
          var dataSource = res.result.records; // 柱状图

          if (_this2.reportType > 1) {
            _this2.loadChartChildrenData(dataSource);
          }
          /*dataSource.push(res.result.min)
          dataSource.push(res.result.max)
          dataSource.push(res.result.avg)*/


          var dataSource = [];

          if (res.result.records) {
            dataSource = res.result.records;
          }

          console.log(dataSource);
          _this2.dataSource = dataSource;
        }

        console.log(_this2.dataSource);

        if (res.code === 510) {
          _this2.$message_custom(res.message, 'warning');
        }

        _this2.loading = false;
      });
    },

    /* 图表相关*/
    // 加载图表数据

    /*loadChartData(record) {
      let that = this
      that.legendData = ['产生固废量']
      that.seriesData = [
        {
          name: '产生固废量',
          data: this.yAxisSolidWasteNumData,
          type: 'bar',
          stack: this.reportType == 1 ? '' : '药剂',
          emphasis: {
            focus: 'series'
          },
          barCategoryGap: '30%'//柱图宽度 投放数量
        }]
       let chartData = record.filter((item, idx) => {
        return item != undefined
      })
      if (0 < chartData.length) {
        chartData.forEach((item, index) => {
          that.xAxisData.push(item.dateStr)
          that.yAxisSolidWasteNumData.push(item.solidWasteNum)
        })
      }
      this.drawChart1()
    },*/
    // 加载子孙图表数据
    loadChartChildrenData: function loadChartChildrenData(record) {
      var that = this;
      that.yAxisSolidWasteNumData = [];
      var chartData = record.filter(function (item, idx) {
        return item != undefined;
      });

      if (0 < chartData.length) {
        that.legendData.push('日常巡检总数', '日常异常', '周巡检总数', '周异常');
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        var arr4 = []; // 日常巡检总数

        chartData.forEach(function (item, index1) {
          // 插入Y轴
          that.xAxisData.push(item.dateStr); // 无数据则为0

          if (item.frequency) {
            arr1.push(item.frequency);
          } else {
            arr1.push(0);
          }
        }); // 日常异常

        chartData.forEach(function (item, index1) {
          // 无数据则为0
          if (item.warnFrequency) {
            arr2.push(item.warnFrequency);
          } else {
            arr2.push(0);
          }
        }); // 周巡检总数

        chartData.forEach(function (item, index1) {
          // 无数据则为0
          if (item.weekFrequency) {
            arr3.push(item.weekFrequency);
          } else {
            arr3.push(0);
          }
        }); // 周异常

        chartData.forEach(function (item, index1) {
          // 无数据则为0
          if (item.weekWarnFrequency) {
            arr4.push(item.weekWarnFrequency);
          } else {
            arr4.push(0);
          }
        });
        var item1 = {
          name: '日常巡检总数',
          data: arr1,
          type: 'bar',
          stack: '日常巡检',
          emphasis: {
            focus: 'series'
          },
          color: that.getColor(0),
          barCategoryGap: '30%' //柱图宽度 投放数量

        };
        var item2 = {
          name: '日常异常',
          data: arr2,
          type: 'bar',
          stack: '日常巡检',
          emphasis: {
            focus: 'series'
          },
          color: that.getColor(1),
          barCategoryGap: '30%' //柱图宽度 投放数量

        };
        var item3 = {
          name: '周巡检总数',
          data: arr3,
          type: 'bar',
          stack: '周巡检',
          emphasis: {
            focus: 'series'
          },
          color: that.getColor(2),
          barCategoryGap: '30%' //柱图宽度 投放数量

        };
        var item4 = {
          name: '周异常',
          data: arr4,
          type: 'bar',
          stack: '周巡检',
          emphasis: {
            focus: 'series'
          },
          color: that.getColor(3),
          barCategoryGap: '30%' //柱图宽度 投放数量

        };
        that.seriesData.push(item1);
        that.seriesData.push(item2);
        that.seriesData.push(item3);
        that.seriesData.push(item4);
      }

      this.drawChart1();
    },
    // 日期变化
    dateChange: function dateChange(value) {
      console.log('日期变化', value);
      this.queryParam.quantum = value;
      this.searchQuery();
    },
    // 周变化
    weekChange: function weekChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
      console.log('周变化', value); // [年,周]

      this.searchQuery();
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
      console.log('月变化', value);
      this.searchQuery();
    },
    // 季度变化
    quarterChange: function quarterChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
      console.log('季度变化', value); // [年,季度]
    },
    // 年变化
    yearChange: function yearChange(value) {
      this.queryParam.quantum = value;
      console.log('年变化', value);
    },
    // 年区间变化
    yearRangeChange: function yearRangeChange(value) {
      this.queryParam.sdateBack = value[0];
      this.queryParam.edateBack = value[1];
      console.log('年区间变化', value);
    },
    // 统计类型变化
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;

      if (this.reportType == '8') {
        this.queryParam.sdateBack = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.quantum = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.edateBack = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    // 监测点变化
    onChange: function onChange(checkedValues) {
      if (checkedValues.length > 1) {
        this.queryParam.flag = '3';
        this.columns = _toConsumableArray(this.columns1);
        this.scroll = {
          y: 460
        };
      } else {
        this.scroll = {
          y: 500
        };

        if (checkedValues[0] == '1') {
          this.queryParam.flag = '2';
          this.columns = _toConsumableArray(this.columns3);
        } else if (checkedValues[0] == '2') {
          this.queryParam.flag = '1';
          this.columns = _toConsumableArray(this.columns2);
        } else {
          this.queryParam.flag = '3';
          this.columns = _toConsumableArray(this.columns1);
          this.scroll = {
            y: 460
          };
        }
      }

      this.loadData(this.reportType);
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.sdateBack = dateString[0];
      this.queryParam.edateBack = dateString[1];
    }
  }
};